/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-divider.get-names.ts 
*/
:host([vertical]),
:host([vertical=true]) {
  align-self: stretch;
  display: inline-flex;
  min-height: 100%;
}
:host([vertical]) hr,
:host([vertical=true]) hr {
  height: 100%;
  width: 0.0625rem;
}

.ace-divider {
  background-color: var(--ace-divider-color);
  border: none;
  height: 0.0625rem;
  margin: 0;
  width: 100%;
}